


"use client"
import type React from "react"
import { useState, useRef, useEffect } from "react"
import { PatternAmount } from "./PatternAmount"
import type { UserProps } from "./apis/user"
import useWindowSize from "./utils/useWindowSize"
import { handleNavigationTobackOffice } from "./utils/NavigateToBackOffice"
import type { remainingPatternsProps } from "./BingoPage"

const bingoGrid = [
  [0, 1, 0, 0, 1],
  [1, 0, 0, 1, 0],
  [0, 0, 2, 0, 0],
  [1, 0, 0, 0, 1],
  [0, 1, 0, 1, 0],
]

interface userProfileProps {
  drawDetails: any
  autoClaim: boolean
  isMobile?: boolean
  toggleAutoClaim: (prev: boolean) => void
  userWallet: UserProps | undefined
  remainingPatterns: remainingPatternsProps | undefined
  userWalletAmount?: any
}

const UserProfile: React.FC<userProfileProps> = ({
  drawDetails,
  userWalletAmount,
  remainingPatterns,
  isMobile,
  toggleAutoClaim,
  autoClaim,
  userWallet,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const menuIconRef = useRef<HTMLImageElement>(null)
  const [size, setSize] = useState({ width: 0, height: 0 })

  const updateSize = () => {
    if (menuIconRef.current) {
      const width = menuIconRef.current.offsetWidth
      const height = menuIconRef.current.offsetHeight
      setSize({ height, width })
    }
  }

  useEffect(() => {
    updateSize()
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  const totalWinCount =
    remainingPatterns !== undefined
      ? remainingPatterns.totalRemaining
      : (Object.values(drawDetails.draw.prizes).reduce((sum, pattern: any) => sum + pattern.winCount, 0) as number)
  const { width, height } = useWindowSize()
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const calculateTotalPrize = () => {
    let totalPrize = 0
    Object.values(drawDetails.draw.prizes).forEach((pattern: any) => {
      totalPrize += pattern.price * pattern.winCount
    })
    return totalPrize
  }
  const totalCount = remainingPatterns !== undefined ? remainingPatterns.totalRemainingPrice : calculateTotalPrize()

  const containerRef = useRef<HTMLDivElement>(null)


  const getUsdWalletAmount = () => {
    if (!userWallet || !userWallet.wallets) {
      return { amount: 0, symbol: "$" }
    }

    const usdWallets = userWallet.wallets.filter((wallet) => wallet.currency && wallet.currency.code === "USD")

    const usdAmount = usdWallets.reduce((sum, wallet) => sum + wallet.amount, 0)

    return { amount: usdAmount, symbol: "$" }
  }

  const { amount: usdAmount, symbol: usdSymbol } = getUsdWalletAmount()
  const handleToggleAutoClaim = () => {
    toggleAutoClaim(autoClaim)
  }

  const amount = userWalletAmount ? userWalletAmount.amount : usdAmount
  const isIpad = width === 1010 && height >= 1300
  return (
    <div ref={containerRef} className={`flex gap-y-2 flex-col md:flex-row xl:flex-col md:gap-4 gap-2`}>
      <div className="flex gap-y-2 flex-col  items-center relative z-50">
        <div
          className={` relative flex  justify-between w-full items-center gap-2`}
        >
          <div
            className={` relative flex gap-2 flex-grow p-1 md:p-2  justify-between   items-center   rounded-lg`}
            style={{ backgroundColor: "#1B0A7F" }}
          >

            <img src="/assets/profile.png" alt="profile" className="lg:w-10  lg:h-10 md:h-[35px] md:w-[35px]  h-6 w-6 object-contain " />


            <div className="relative overflow-hidden flex flex-grow ">
              {/* <img src="assets/walletBg.png" alt="wallet-bg" className="absolute inset-0 z-[1]" /> */}
              <div className="w-full relative z-10 gap-2  flex items-center justify-end  ">
                <span
                  className={` text-white font-bold text-xs md:text-base lg:text-xl  z-20`}
                >
                  {usdSymbol}
                  {amount}
                </span>
                <img
                  src="/assets/coin.png"
                  alt="coin"
                  className="md:w-8 md:h-8 w-4 h-4 object-contain"
                />
              </div>
            </div>

          </div>
          <div className=" gap-x-1   flex justify-end relative">
            <img
              src={autoClaim ? "/assets/autoClaim.png" : "/assets/nonAutoClaim.png"}
              alt="autoClaim"
              className={`lg:w-12 md:w-11 md:h-11 lg:h-12  w-8 h-8 cursor-pointer`}
              onClick={handleToggleAutoClaim}
              title="Auto Mark"
            />
            <div className="relative ">
              <img
                ref={menuIconRef}
                src="/assets/menu.png"
                title="Menu"
                alt="menuicon"
                className={`lg:w-12 md:w-11 md:h-11 lg:h-12  w-8 h-8 cursor-pointer`}
                onClick={toggleMenu}
              />
              {isMenuOpen && (
                <div className="absolute right-0 top-full flex flex-col items-center gap-1" style={{ zIndex: 999, paddingTop: isIpad ? '12px' : undefined }}>
                  <button title="Home" className={`flex items-center justify-center`} onClick={handleNavigationTobackOffice}>
                    <img
                      src="/assets/home.png"
                      alt="home"
                      className="lg:w-12 md:w-11 md:h-11 lg:h-12  w-8 h-8" />
                  </button>
                  <button title="Close" className={`flex items-center justify-center`} onClick={handleNavigationTobackOffice}>
                    <img
                      src="/assets/cancel.png"
                      alt="close"
                      className="lg:w-12 md:w-11 md:h-11 lg:h-12  w-8 h-8" />
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>

        <div
          className={`w-full  md:py-2 py-1 flex items-center justify-between md:px-4 px-2`}
          style={{
            backgroundImage: `url('/assets/blueBg.png')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
          }}
        >
          <div className="flex items-center">
            <img
              src={"/assets/moneyBox.png"}
              alt="Treasure Chest"
              className={`${width === 1010 ? "w-16 h-10" : "xl:w-16 lg:w-12 lg:h-8 md:w-12 w-10 h-6 -mt-1 md:-mt-0 md:h-8 xl:h-10 mr-2"}`}
            />
            <span style={{ fontSize: isIpad ? '13px' : undefined }} className={`text-white md:h-5 w-full px-1  lg:-ml-10 -ml-10 mt-4 flex items-center justify-center lg:h-6 bg-[#2176CD] text-[9px] md:text-[12px] rounded-2xl xl:text-[14px] lg:text-[12px] font-bold`}>
              {totalCount}
            </span>
          </div>

          <div className="flex flex-col items-center">
            <span
              className={`text-white ${width === 1010 ? "text-[18px]" : "text-sm md:text-[14px] lg:text-md xl:text-2xl"} font-bold`}
            >
              {totalWinCount}
            </span>
            <span
              className={`text-white font-semibold ${width <= 420 ? "text-[12px] -mt-1" : width === 1010 ? "text-[18px]" : "xl:text-lg lg:text-md md:text-[14px] md:-mt-1 text-[12px]"} `}
            >
              Bingos Left
            </span>
          </div>

          <div className="grid grid-cols-5 gap-1">
            {bingoGrid.flat().map((cell, index) => (
              <div
                key={index}
                className="w-[2px] h-[2px] md:w-1 md:h-1 lg:w-1 lg:h-1 border border-white flex items-center justify-center"
              >
                {cell === 2 && <div className="w-1 h-1 bg-red-500 rounded-sm"></div>}
              </div>
            ))}
          </div>
        </div>
      </div>

      <PatternAmount drawDetails={drawDetails} isMobile={isMobile} />
    </div>
  )
}

export default UserProfile